import { FixedDistributionAccount, } from '@debbie/common/dist/economy/fixed-distributions/index.js';
import { getVoucherLabel } from '@debbie/common/dist/economy/helpers/vouchers.js';
import moment from 'moment';
import React from 'react';
import THEME from '../../../theme.js';
import { toPercent } from '../../../utils/index.js';
import AssociationIcon from '../../Icons/AssociationIcon.js';
import InfoIcon from '../../Icons/Info.js';
import { Badge, Money } from '../../index.js';
import { Amount, AmountCol, DateText, Info, Label, Meta, Percentage, ReferenceId, RemainingRow, RightCol, Row, } from './CaseVoucherDistributionsStyles.js';
import { fixedDistributionLabel } from './fixed-distribution-label.js';
const CaseVoucherDistributionsView = ({ voucher, caseVouchers, fixedDistributions, lang, onShowVoucherInfo, }) => {
    return (React.createElement(React.Fragment, null,
        (voucher.distribution || []).map((dist, index) => {
            const targetVoucher = caseVouchers.find((cv) => cv.caseVoucherId === dist.caseVoucherId);
            const voucherLabel = targetVoucher
                ? getVoucherLabel(targetVoucher, lang)
                : dist.caseVoucherId;
            const fd = dist.fixedDistributionId
                ? fixedDistributions?.find((f) => f.id === dist.fixedDistributionId)
                : null;
            const isCreditorFd = fd?.account === FixedDistributionAccount.Creditor;
            const displayAmount = Math.abs(dist.amount);
            return (React.createElement(Row, { key: dist.fixedDistributionId ??
                    `dynamic-${dist.caseVoucherId}-${index}`, $deleted: false },
                React.createElement(Info, null,
                    React.createElement(Label, null,
                        targetVoucher && (React.createElement(InfoIcon, { style: {
                                cursor: 'pointer',
                                userSelect: 'none',
                                flexShrink: 0,
                            }, onClick: () => onShowVoucherInfo(targetVoucher) })),
                        voucherLabel,
                        targetVoucher?.interest
                            ? ` ${parseFloat((targetVoucher.interest * 100).toFixed(3))} %`
                            : null,
                        fd?.associationId && (React.createElement(AssociationIcon, { "data-tooltip-id": "tooltip-default", "data-tooltip-content": lang.associateCases.associateCase })),
                        targetVoucher?.referenceId && (React.createElement(ReferenceId, { title: targetVoucher.referenceId },
                            "(",
                            targetVoucher.referenceId,
                            ")"))),
                    React.createElement(Meta, null,
                        targetVoucher && (React.createElement(DateText, null, moment(targetVoucher.date).format(THEME.DATE_FORMAT_SHORT))),
                        fd ? (React.createElement(Badge, { theme: isCreditorFd ? THEME.COLOR_GREY : THEME.COLOR_ACCENT }, fixedDistributionLabel(lang, fd))) : (React.createElement(Badge, { theme: THEME.COLOR_GREY }, lang.economy.voucherInfoDistributionDynamic)))),
                React.createElement(RightCol, null,
                    React.createElement(AmountCol, null,
                        React.createElement(Amount, null,
                            React.createElement(Money, { amount: displayAmount })),
                        React.createElement(Percentage, null,
                            toPercent(displayAmount / (Math.abs(voucher.amount) || 1), {
                                precision: 2,
                            }),
                            ' ',
                            "%")))));
        }),
        (() => {
            const totalDistributed = (voucher.distribution || []).reduce((sum, d) => sum + Math.abs(d.amount), 0);
            const remaining = Math.abs(voucher.amount) - totalDistributed;
            if (remaining > 0 && (voucher.distribution || []).length > 0) {
                return (React.createElement(RemainingRow, null,
                    React.createElement(Label, null, lang.economy.voucherInfoDistributionRemaining),
                    React.createElement(AmountCol, null,
                        React.createElement(Amount, null,
                            React.createElement(Money, { amount: remaining })),
                        React.createElement(Percentage, null,
                            toPercent(remaining / (Math.abs(voucher.amount) || 1), {
                                precision: 2,
                            }),
                            ' ',
                            "%"))));
            }
            return null;
        })()));
};
export default CaseVoucherDistributionsView;
//# sourceMappingURL=CaseVoucherDistributionsView.js.map